export const SITE_CONFIG = {
  name: 'StemBears',
  description: 'Fun and interactive STEM education for kids. Learn electronics, coding, and science through hands-on projects!',
  url: 'https://stembears.com',
  logo: '/logo/logo_main.png',
  social: {
    twitter: '@stembears',
    facebook: 'stembears',
    instagram: 'stembears',
    youtube: 'stembears'
  }
}

export const NAVIGATION = [
  { name: 'Home', href: '/', icon: 'Home' },
  { name: 'Programs', href: '/programs', icon: 'BookOpen' },
  { name: 'Blogs', href: '/blogs', icon: 'BookOpen' },
  { name: 'About', href: '/about', icon: 'Users' },
  { name: 'Contact', href: '/contact', icon: 'Mail' },
]

export const PROGRAM_CATEGORIES = [
  { id: 'all', name: 'All Programs', icon: 'BookOpen' },
  { id: 'level1', name: 'Explorer Champions', icon: 'Cpu' },
  { id: 'level2', name: 'Tech Warriors', icon: 'Code' },
  { id: 'level3', name: 'Innovation Masters', icon: 'Microscope' },
  { id: 'online', name: 'Do It Yourself Kits', icon: 'Calculator' },
  { id: 'programs', name: 'Special Programs', icon: 'Calculator' },
  { id: 'workshops', name: 'STEM Workshops', icon: 'Award' },
]

export const ANIMATION_VARIANTS = {
  fadeInUp: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  },
  fadeInLeft: {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.6 }
  },
  fadeInRight: {
    initial: { opacity: 0, x: 20 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.6 }
  },
  stagger: {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  }
}
